import { render } from "./SettingsPlaceholderSection.vue?vue&type=template&id=3dc59a3e"
import script from "./SettingsPlaceholderSection.vue?vue&type=script&lang=js"
export * from "./SettingsPlaceholderSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__